import { tracked } from '@glimmer/tracking';

import type { DSSetup } from 'webapp-types';
import { MetricFilterOperator, Unit } from 'webapp/enums/enums';

import type { MetricFromClient } from 'webapp/models-custom';
import type { MetricSetupBaseProps, OnChangeFn } from 'webapp/models-custom/metric-setup-base';
import MetricSetupBase from 'webapp/models-custom/metric-setup-base';

export interface Props extends MetricSetupBaseProps {
	metric?: MetricFromClient;
}

export default class MetricSetupForClient extends MetricSetupBase {
	@tracked private _metric: MetricFromClient | null = null;

	constructor(props: Props = {}, onChange?: OnChangeFn) {
		super(props);

		if (props.metric) {
			this.setMetric(props.metric);
		}

		this.afterMetricSet(props, onChange);
	}

	get metric(): MetricFromClient | null {
		return this._metric;
	}

	get defaultUnit(): string {
		return Unit.EMPTY;
	}

	override get metricOperatorLimitations(): MetricFilterOperator[] {
		return [MetricFilterOperator.ANY_OF];
	}

	override setFromMetricData(metricData: DSSetup.MetricData): void {
		super.setFromMetricData(metricData);
		this.resetDimensionsAndFilters();
	}

	setMetric(metric: MetricFromClient): void {
		this._metric = metric;
	}
}
